import reducers from "./userProfileReducers";

export default reducers;
